export default "__VITE_ASSET__CB6uCvf7__"